import React, { useState } from "react";
import { Box, Typography, Slider } from "@mui/material";
import AngryFace from "../../../assets/moods/Angry Face.svg";
import DeadFace from "../../../assets/moods/Dead Face.svg";
import UnhappyFace from "../../../assets/moods/Unhappy Face.svg";
import SmileFace from "../../../assets/moods/Smile Face.svg";
import HappyFace from "../../../assets/moods/Happy Face.svg";

const MoodCheck = ({ onResponseChange }) => {
  const [sliderValue, setSliderValue] = useState(3); // Continuous slider value
  const [highlightedMood, setHighlightedMood] = useState(3); // Threshold-based mood

  const emojiList = [
    { value: 1, src: AngryFace, alt: "Angry" },
    { value: 2, src: DeadFace, alt: "Dead" },
    { value: 3, src: UnhappyFace, alt: "Unhappy" },
    { value: 4, src: SmileFace, alt: "Smile" },
    { value: 5, src: HappyFace, alt: "Happy" },
  ];

  const thresholds = emojiList.map((emoji) => emoji.value);

  const handleMoodChange = (event, newValue) => {
    setSliderValue(newValue);

    // Categorize mood based on thresholds
    let moodCategory;
    if (newValue <= 1) moodCategory = "Very Unhappy";
    else if (newValue <= 2) moodCategory = "Unhappy";
    else if (newValue <= 3) moodCategory = "Neutral";
    else if (newValue <= 4) moodCategory = "Happy";
    else moodCategory = "Very Happy";

    onResponseChange && onResponseChange("moodCheck", moodCategory);

    // Determine the closest threshold and update highlightedMood
    const closestMood = thresholds.reduce((prev, curr) =>
      Math.abs(curr - newValue) < Math.abs(prev - newValue) ? curr : prev
    );

    // Only update the highlighted mood if it changes
    if (closestMood !== highlightedMood) {
      setHighlightedMood(closestMood);
    }
};


  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh", 
        backgroundColor: "background.default",
        padding: "2rem",
        boxSizing: "border-box",
        borderRadius: "12px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      {/* Title */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: 600,
          marginBottom: "1rem",
          textAlign: "center",
          color: "#333",
        }}
      >
        Daily Mood Check
      </Typography>

      {/* Subheading */}
      <Typography
        variant="body1"
        sx={{
          fontSize: "1.25rem",
          textAlign: "center",
          marginBottom: "2rem",
          color: "#666",
        }}
      >
        Pull the slider to the emotion that corresponds with how you feel
      </Typography>

      {/* Emoji Display */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          marginBottom: "1rem",
          padding: "0 10%",
        }}
      >
        {emojiList.map((emoji) => (
          <img
            key={emoji.value}
            src={emoji.src}
            alt={emoji.alt}
            style={{
              width: "48px",
              filter: highlightedMood === emoji.value ? "none" : "grayscale(100%)", // Highlight selected emoji
              transition: "filter 0.3s ease-in-out", // Smooth transition
            }}
          />
        ))}
      </Box>

      {/* Slider */}
      <Slider
        value={sliderValue}
        onChange={handleMoodChange}
        step={0.01} // Smooth slider movement
        min={1}
        max={5}
        sx={{
          width: "80%",
          color: "primary.main",
          "& .MuiSlider-thumb": {
            width: "28px",
            height: "28px",
            backgroundColor: "white",
            border: "2px solid #4A90E2", // Blue border for thumb
          },
          "& .MuiSlider-track": {
            height: "10px",
            borderRadius: "4px",
            background: `linear-gradient(to right, #FF5B5B, #FFC300, #8BC34A)`, // Gradient for track
          },
          "& .MuiSlider-rail": {
            height: "10px",
            borderRadius: "4px",
            backgroundColor: "#E0E0E0",
          },
        }}
      />
    </Box>
  );
};

export default MoodCheck;
